import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'ar_EG', // Locale
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  }, // Features
  {
    fssInputCategory: false, // Search input version
  },
  '1af0a9c8-4a7b-4901-8745-7f80c5922a41', // Search profile
  'rtl' // Text direction
);
